import {
  EMAIL_CAPTURE,
  LEAD_FORM_SUBMIT,
  DRUPAL_AB_TEST,
  REDIRECT_TO_CAPTCHA,
  HMAC_INVALID_WEBFORM_SUBMIT,
  CAPTCHA_SUBMIT_SUCCESS,
  RECAPTCHA_BOT_SCORE,
  RECAPTCHA_ASSESSMENT_ID,
  INTERCOM_MESSENGER_OPENED,
  INTERCOM_MESSENGER_CLOSED,
  INTERCOM_MESSAGE_UNREAD_COUNT_CHANGED,
} from "@/eventIds";
import { eventIdMap } from './eventMap';
import { sendWAEvent } from '@/utils/waHelpers';

export default {
  fireEvent(id, data) {
    sendWAEvent(eventIdMap[id] ?? id, JSON.stringify(data));
  },
  [EMAIL_CAPTURE](id, data) {
    sendWAEvent(eventIdMap[id], `Lead Gen Form: Email Captured`);
  },
  [LEAD_FORM_SUBMIT](id, data) {
    sendWAEvent(eventIdMap[id], `${data.form_name} submitted on ${data.form_url}`);
  },
  [DRUPAL_AB_TEST](id, data) {
    sendWAEvent(data.event_id, data.split_winner + ' | ' + data.split_description + ' | ' + data.title);
  },
  [REDIRECT_TO_CAPTCHA](id, data) {
    sendWAEvent(eventIdMap[id], `${data.message}`);
  },
  [HMAC_INVALID_WEBFORM_SUBMIT](id, data) {
    sendWAEvent(eventIdMap[id], `${data.message}`);
  },
  [CAPTCHA_SUBMIT_SUCCESS](id, data) {
    sendWAEvent(eventIdMap[id], `${data.message}`);
  },
  [RECAPTCHA_BOT_SCORE](id, data) {
    sendWAEvent(eventIdMap[id], `Score: ${data.score} | ${data.reasons}`);
  },
  [RECAPTCHA_ASSESSMENT_ID](id, data) {
    sendWAEvent(eventIdMap[id], `${data.assessment_id}`);
  },
  [INTERCOM_MESSENGER_OPENED](id, data) {
    sendWAEvent(eventIdMap[id], `${data.message}`);
  },
  [INTERCOM_MESSENGER_CLOSED](id, data) {
    sendWAEvent(eventIdMap[id], `${data.message}`);
  },
  [INTERCOM_MESSAGE_UNREAD_COUNT_CHANGED](id, data) {
    sendWAEvent(eventIdMap[id], `${data.message}`);
  },
}